<template>
  <div v-show="show" class="container" :style="{ height: windowHeight + 'px' }">
    <!-- <van-nav-bar
      title="订单详情"
      left-text=""
      left-arrow
      fixed
      placeholder
      @click-left="onClickLeft"
    /> -->

    <div class="stateBox">
      <div class="stateCont">
        <div class="left">
          <van-icon name="shop-o" size="25" />&emsp;
          <label>{{ orderState }}</label>
        </div>
        <div class="right">
          <label>{{ orderMessage1 }}</label>
          <br />
          <label>{{ orderMessage2 }}</label>
        </div>
      </div>
    </div>

    <van-cell
      size="large"
      style="
        text-align: left;
        margin: 20px 0 20px 0;
        word-wrap: break-word;
        word-break: break-all;
      "
      :title="address"
      icon="location-o"
    >
      <template #label>
        <div style="margin: 10px 0 10px 0">
          <label>收件人:</label>&ensp;
          <label style="color: black">{{ consignee }}</label>
        </div>
        <label>联系电话:</label>&ensp;
        <label style="color: black">{{ phone }}</label>
      </template>
    </van-cell>

    <van-cell
      size="large"
      style="text-align: left"
      title="货品信息"
      icon="shopping-cart-o"
    >
    </van-cell>
    <van-card
      style="text-align: left; margin: 0 0 20px 0"
      :title="title"
      :thumb="img"
    >
      <template #desc>
        <div class="showDetails">
          {{ desc }}
          <div style="position: absolute; margin-top: 10px">
            <label>套餐价:{{ value }}元</label>
          </div>
        </div>
      </template>
    </van-card>

    <van-cell size="large" title style="text-align: left">
      <template #label>
        <div style="margin: 0 0 10px 0">
          <label>订单编号:</label>&ensp;
          <label style="color: black">{{ orderNo }}</label>
        </div>
        <div>
          <label>下单时间:</label>&ensp;
          <label style="color: black">{{ orderDate }}</label>
        </div>
        <div style="margin: 10px 0 0 0" v-if="logisticsNumber != null">
          <label>快递单号:</label>&ensp;
          <label style="color: black">{{ logisticsNumber }}</label>
        </div>
        <div style="margin: 10px 0 0 0">
          <label>卡券编码:</label>&ensp;
          <label style="color: black">{{ cardNo }}</label>
        </div>
        <div style="margin: 10px 0 0 0">
          <label>绑定时间:</label>&ensp;
          <label style="color: black">{{ bindTime }}</label>
        </div>
        <div style="margin: 10px 0 0 0" v-if="situation == 3">
          <label>发货状态:</label>&ensp;
          <label style="color: black">{{ orderState }}</label>
        </div>
        <div style="margin: 10px 0 0 0" v-if="situation == 3">
          <label>发货时间:</label>&ensp;
          <label style="color: black">{{ delTime }}</label>
        </div>
      </template>
    </van-cell>

    <van-cell size="large" title class="bottom">
      <template #default>
        <van-button
          size="small"
          v-if="logisticsNumber != null"
          @click="logistics"
          type="default"
          >查看物流</van-button
        >&emsp;
        <van-button
          size="small"
          @click="continueReceive"
          type="default"
          v-if="isShowReceive == 'true'"
          >继续领取</van-button
        >
      </template>
    </van-cell>
  </div>
</template>

<script>
import api from "../../common/js/api";
export default {
  data() {
    return {
      windowHeight: document.documentElement.clientHeight, //实时屏幕高度
      title: "", //商品标题
      desc: "", //描述信息
      img: "", //商品图片
      logisticsNumber: "", //快递单号
      show: true, //是否显示页面
      address: "", //收货地址
      consignee: "", //收货人
      phone: "", //联系电话
      orderNo: "", //订单编号
      orderDate: "", //下单时间
      orderState: "", //订单状态
      value:"", //面值
      orderMessage1: "",
      orderMessage2: "",
      isShowReceive: "true",
      cardNo: "",
      bindTime: "",
      delTime: "",
      situation: -1,
    };
  },

  components: {},

  computed: {},

  created() {
    this.isShowReceive = this.$route.query.isShowReceive;
    this.getData();
  },

  mounted() {},

  methods: {
    //获取订单详情信息
    getData() {
      this.$post(api.getByCardNo, {
        cardNo: this.$route.query.voucherCode,
      }).then((res) => {
        //status=1，表示未绑卡，=2表示已经绑卡，=3表示已经领取
        if (res.success) {
          this.id = res.data.id;
          switch (res.data.status) {
            case 1:
              this.show = false;
              this.$dialog
                .alert({
                  title: "错误",
                  message: "该卡为空卡，请联系客服",
                })
                .then(() => {
                  this.$router.replace("/");
                });
              break;
            case 2:
              this.show = false;
              this.$dialog
                .alert({
                  title: "错误",
                  message: "该卡尚未领取，请先领取",
                })
                .then(() => {
                  this.onClickLeft();
                });
              break;
            case 3:
              this.address = res.data.address.address;
              this.consignee = res.data.address.consignee;
              this.phone = res.data.address.phone;
              this.img = res.data.options.picture;
              this.title = res.data.options.title;
              this.desc = res.data.options.info;
              this.orderNo = res.data.orderNo;
              this.orderDate = res.data.createTime;
              this.logisticsNumber = res.data.expressNo;
              this.cardNo = res.data.cardNo;
              this.bindTime = res.data.bindTime;
              this.delTime = res.data.delTime;
              this.situation = res.data.situation;
              this.value=res.data.options.value;
              //订单状态 1未支付 2未发货 3已发货 4交易成功
              switch (res.data.situation) {
                case 1:
                  this.orderState = "";
                  break;
                case 2:
                  this.orderState = "待发货";
                  this.orderMessage1 = "商家待发货";
                  this.orderMessage2 = "请耐心等待商家发货";
                  break;
                case 3:
                  this.orderState = "已发货";
                  this.orderMessage1 = "商家已发货";
                  this.orderMessage2 = "货物正在运输中";
                  break;
                case 4:
                  this.orderState = "交易完成";
                  this.orderMessage1 = "";
                  this.orderMessage2 = "";
                  break;
              }
              break;
          }
        } else {
          this.show = false;
          this.$dialog
            .alert({
              title: "错误",
              message: "该卡为空卡，请联系客服",
            })
            .then(() => {
              this.$router.replace("/");
            });
        }
      });
    },
    //返回
    onClickLeft() {
      this.$router.replace({
        path: "/searchResult",
        query: { voucherCode: this.$route.query.voucherCode },
      });
    },
    //继续领取
    continueReceive() {
      this.$router.replace({
        path: "/customerSearch",
      });
    },
    //查看物流
    logistics() {
      window.location.href =
        "https://m.baidu.com/from=1001192y/s?word=" +
        this.logisticsNumber +
        "&ts=0221530&t_kt=0&ie=utf-8&fm_kl=502770f412&rsv_iqid=3932057501&rsv_t=4d0ciNbLD4%252BpAPcVhJqVth2wGGvzKgnvjBuhb5udrFkc5dG47AMaX35Ctia9ov8&sa=ib&rsv_pq=3932057501&rsv_sug4=4524&ss=110&tj=1&inputT=593&sugid=2070751438280796965";
    },
  },
};
</script>
<style lang='scss' scoped>
.container {
  width: 100%;
  background-color: rgba(247, 243, 249, 1);
  .stateBox {
    width: 100%;
    background: url(https://presale.jhtsoft.com/picms/388009ad267fd2.png)
      #f53033 repeat-x bottom;
    background-size: 30rem auto;
    animation: stateBox 8s infinite linear;
    .stateCont {
      height: 60px;
      position: relative;
      display: -ms-flexbox;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 1rem;
      color: #fff;
      background: url(https://presale.jhtsoft.com/picms/38800c34100068.png)
        repeat-x bottom;
      background-size: 30rem auto;
      animation: stateBox 12s infinite linear;
      .left {
        display: flex;
        align-items: center;
      }
      .right {
        text-align: right;
      }
    }
  }
  .bottom {
    position: absolute;
    bottom: 0;
  }
}
@keyframes stateBox {
  from {
    background-position: -40rem bottom;
  }
  to {
    background-position: 0 bottom;
  }
}
</style>